import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import { Button, Icon } from "@alternative/components";
import { IconNames } from "@alternative/icons";
const Toast = (props) => {
  const { message, onDismiss, canDismiss = true, timeout = 3000, className } = props;
  const timerRef = useRef();
  const startTimeout = (callback) => {
    timerRef.current = setTimeout(() => {
      if (callback) callback();
    }, timeout);
  };
  const clearTimeouts = () => clearTimeout(timerRef.current);
  useEffect(() => {
    if (canDismiss) startTimeout(onDismiss);
    return () => clearTimeouts();
  }, [message, onDismiss, canDismiss]);
  return (
    <div
      className={classNames("bp3-toast", className)}
      onBlur={() => startTimeout(onDismiss)}
      onFocus={clearTimeouts}
      onMouseEnter={clearTimeouts}
      onMouseLeave={() => startTimeout(onDismiss)}
      tabIndex={0}
    >
      <span className="bp3-toast-message">{message}</span>
      {canDismiss ? (
        <Button className="dismiss-button" minimal small onClick={onDismiss}>
          <Icon icon={IconNames.CLOSE} />
        </Button>
      ) : (
        <span className="dismiss-button" />
      )}
    </div>
  );
};

export default Toast;
